module.exports = __webpack_public_path__ + "static/media/inktoberMoon.76dae208.gif";